import { Outlet, useLocation } from "react-router-dom";
import DefaultHeader from "./DefaultHeader";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const DefaultLayout = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const loggedId = useSelector((state) => state.auth.loggedIn);

  const [addMode, setAddMode] = useState(
    !location.pathname.includes("/produk/")
  );
  const [isOnEditingPage, setIsOnEditingPage] = useState(false);

  // use effect section

  useEffect(() => {
    setAddMode(!location.pathname.includes("/produk/"));
    setIsOnEditingPage(location.pathname.includes("/edit-produk/"));
  }, [location.pathname]);

  // handle ui event section

  const handleClickTambahEdit = () => {
    if (addMode) {
      navigate("/edit-produk/new");
    } else {
      if (location.pathname.includes("/produk/") && id && id > 0) {
        navigate(`/edit-produk/${id}`);
      }
    }
  };

  return (
    <>
      <div className="relative col-start-center w-100">
        <ConfirmDialog />

        {loggedId && !isOnEditingPage && (
          <Button
            className="fixed !p-7 z-50 bottom-5 right-4 shadow-lg hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-opacity-75"
            rounded
            severity="success"
            icon={addMode ? "pi pi-plus" : "pi pi-pencil"}
            pt={{ icon: { className: "!text-xl" } }}
            onClick={handleClickTambahEdit}
          />
        )}

        {/* <Dialog
          className="mt-6"
          showHeader={false}
          contentStyle={{ padding: "0", borderRadius: "0.5rem" }}
          position={"top-right"}
          visible={showProfileDialog}
          modal={false}
          style={{
            width: "50vw",
            marginTop: "calc(var(--height-nav-bar) + 12px )",
          }}
          draggable={false}
          resizable={false}
          onHide={() => setShowProfileDialog(false)}
        >
          <FloatingProfilePage hidden={false} />
        </Dialog> */}

        <DefaultHeader />
        <main className="w-full md:w-[820px] max-w[820px]">
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default DefaultLayout;
